import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import {
  useModalAttributes,
  useFocusFinders,
  makeStyles,
  OptionOnSelectData,
  SelectionEvents,
  CheckboxOnChangeData,
  TextareaOnChangeData
} from "@fluentui/react-components";
import { ResourceSpaceType } from "../../APIService/ResourceSpaceTypeListService";
import "./ResourceSpaceTypeModel.css";
import ResourceSpaceMapSection, { DataObject, MapsIFrameData } from "./ResourceSpaceMapSection";
import ResourceSpaceFindSection from "./ResourceSpaceFindSection";
import { getSettings } from "../../viewmodel/getsettings";
import moment from "moment";
import { floorToInterval, getDaySuffix, getOrdinal, getWeekOfMonth, roundUpTime } from '../../utils/DateHelper';
import SearchService, { Equipment, GetAvailableResourceListRequest, Resource, ResourceLocation, User, UserSearchRequest } from "../../APIService/SearchService";
import { CommonInfo } from "../../CommonData/Config";
import ResourceSpaceBooking from "./ResourceSpaceBooking";
import UserBookingService, { BookOption, CreateBookingRequest, CreateBookingResponse, DateTimeObject, ResourceAvailabilityCheckRequest, ResourceAvailabilityCheckResponse, SelectedResourceObject } from "../../APIService/UserBookingService";
import ToastrService from "../toaster/ToastrService";
import MapsService, { GetMapHotspotsRequest, GetMapHotspotsResponse, GetMapsEnhancedResponse, GetMapsLocation, GetMapsRequest, GetMapsResponse } from "../../APIService/Maps";
import RXRTEView from "../RXTextEditor";

import Swal from "sweetalert2";
import loaderService from "../loader/loader.service";
import { useTeamsContext } from "../../utils/useTeamsContext";
import ConflictView from "./ConflictView";
import { t } from "../../utils/language";

type ResourceSpaceTypeModelProps = {
  spaceDetails: ResourceSpaceType;
  allSpaceTypes: ResourceSpaceType[];
  selectedDate: Date,
  onCloseModel: (isSuccess: boolean, bookingDate?: Date) => void;
};

const useStyles = makeStyles({
  container: {
    position: "fixed",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    inset: "0",
    overflow: "unset",
    display: "flex",
    flexDirection: "column",
    // height: "100%",
  },
  dialog: {
    margin: "20px 100px",
    height: "calc(100vh - 40px)",
    width: "calc(100vw - 200px)",
    border: "2px solid #525252",
    borderRadius: "5px",
    backgroundColor: "#1A1A1A",
    boxShadow: "0px 4px 10px 4px #00000040"
  },

  footer: {
    display: "flex",
    marginTop: "auto",
    justifyContent: "end",
    gap: "5px",
  },

  optionContainer: {
    width: "100%",
    margin: "0px 15px 15px 15px",
    flex: 1,
    overflowX: "hidden",
    overflowY: "auto"
  },

  textInput: {
    width: "90%",
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    margin: "10px 0px -5px 0px",
  },

  dropDownContainer: {
    display: "flex",
    alignItems: "center",
    margin: "15px 30px 0px 0px",
  },

  dropDown: {
    width: "100%",
  },

  timePickerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    margin: "10px 30px 0px 30px",
    // justifyContent: "space-evenly",
    height: "30px"
  },

  timePicker: {
    flex: 1,
    minWidth: 0,
    height: "30px"
    // width: "40%",
  },

  profileContainer: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0px 0px 0px",
  },

  profile: {
    display: "flex",
    backgroundColor: "blue",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "3px 5px 3px 5px",
    borderRadius: "5px",
  },

  iconContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    alignItems: "center",
  },

  closeIcon: {
    display: "none",
  },

  bookingScroll: {
    borderRight: "1px solid #525252",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden"
  },
  endDate: {
    display: "flex",
    alignItems: "center",
    height: "32px",
    justifyItems: "center",
    justifyContent: "center",
    flex: 1
  },
  separator: {
    width: "24px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  endDateLabel: {
    width: "70px",
    height: "20px",
    fontSize: "14px",
    lineHeight: "20px",
    flexWrap: "nowrap"
  },
  indicator: {
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    boxShadow: "none",

    // removes focus ring on indicator
    ":focus-within": {
      outline: "none",
      boxShadow: "none",
    },
  }
});

const ResourceSpaceSideBar = ({
  isFind,
  setIsFind,
  theme
}: {
  isFind: boolean;
  theme: string;
  setIsFind: (value: boolean) => void;
}) => {
  return (
    <>
      <div className="sideBar">
        <div className="sideBarContent" onClick={() => setIsFind(true)}>
          <div
            style={{
              backgroundColor: isFind ? theme === "dark" ? "#124779" : "#C9E1F8" : "",
              padding: isFind ? "5px 10px 5px 10px" : 0,
              borderRadius: 20,
            }}
          >
            <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/findlight.svg' : '/find.svg'}`} style={{ width: 22, height: 22 }} />
          </div>
          <span>{t('Find')}</span>
        </div>
        <div className="sideBarContent" onClick={() => setIsFind(false)}>
          <div
            style={{
              backgroundColor: !isFind ? theme === "dark" ? "#124779" : "#C9E1F8" : "",
              padding: !isFind ? "5px 10px 5px 10px" : 0,
              borderRadius: 20,
            }}
          >
            <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/maplight.svg' : '/map.svg'}`} style={{ width: 22, height: 22 }} />
          </div>
          <span>{t('Map')}</span>
        </div>
      </div>
    </>
  );
};

export type RecurringOption = {
  label: string;
  value: number;
};

const ResourceSpaceTypeModel = ({
  spaceDetails,
  allSpaceTypes,
  selectedDate,
  onCloseModel
}: ResourceSpaceTypeModelProps) => {
  const { themeString } = useTeamsContext();
  const styles = useStyles();
  const getSettingsData = getSettings;
  const theme = localStorage.getItem("Theme");
  const userIdString = localStorage.getItem('userId');
  const SLIDER_STEP = 15;
  let userId: any;
  if (userIdString !== null) {
    userId = parseInt(userIdString);
  }
  const secondaryBookOptions: BookOption[] = [
    {
      name: "Custom",
      id: 0,
      code: "",
      bookIndex: "0",
    },
    {
      name: "AM",
      id: 10,
      code: "AM",
      bookIndex: "10",
    },
    {
      name: "PM",
      id: 11,
      code: "PM",
      bookIndex: "11",
    },
    {
      name: "End of day",
      id: 12,
      code: "EOD",
      bookIndex: "12",
    },
    {
      name: "Working Day",
      id: 14,
      code: "WD",
      bookIndex: "14",
    },
    {
      name: "All day",
      id: 15,
      code: "AD",
      bookIndex: "15",
    }
  ];

  const [open, setOpen] = React.useState(true);
  const [isFind, setIsFind] = useState<boolean>(false);
  const [bookingDate, setBookingDate] = useState<Date>(selectedDate);
  const [recurringOptions, setRecurringOptions] = useState<RecurringOption[]>([]);
  const [selectedRecurring, setSelectedRecurring] = useState<RecurringOption | null>(null);
  const [bookOptions, setBookOptions] = useState<BookOption[]>([]);
  const [selectedBookOption, setSelectedBookOption] = useState<BookOption>(secondaryBookOptions[0]);
  const [searchTags, setSearchTags] = useState<string[]>([]);
  const [equipmentList, setEquipmentList] = useState<Equipment[]>([]);
  const [availableResourceList, setAvailableResourceList] = useState<Resource[]>([]);
  const availableResourcesRef = useRef<Resource[]>([]);
  const [selectedResourceList, setSelectedResourceList] = useState<SelectedResourceObject[]>([]);
  const [bookingStartTime, setBookingStartTime] = useState<Date>(
    roundUpTime(selectedDate, 15)
  );
  const bookingStartTimeRef = useRef<Date>(roundUpTime(selectedDate, 15));
  const [bookingEndTime, setBookingEndTime] = useState<Date>(
    roundUpTime(moment(selectedDate).add(15, "minutes").toDate(), 15)
  );
  const bookingEndTimeRef = useRef<Date>(roundUpTime(moment(selectedDate).add(15, "minutes").toDate(), 15));
  const [reccuringEndDate, setRecurringEndDate] = useState<Date | null>(null);
  const reccuringEndDateRef = useRef<Date | null>(null);
  const [getMapsResponse, setGetMapsResponse] = useState<GetMapsEnhancedResponse | null>(null);
  const getMapsResponseRef = useRef<GetMapsEnhancedResponse | null>(null);
  const [getMapHotspotsResponse, setGetMapHotspotsResponse] = useState<GetMapHotspotsResponse | null>(null);
  const { triggerAttributes, modalAttributes } = useModalAttributes({
    legacyTrapFocus: true,
    trapFocus: true,
  });
  const { findFirstFocusable } = useFocusFinders();
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const dialogRef = React.useRef<HTMLDivElement>(null);

  //Selected values
  const [selectedSpaceType, setSelectedSpaceType] = useState<ResourceSpaceType>(spaceDetails);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedEquipments, setSelectedEquipments] = useState<Equipment[]>([]);

  const [searchText, setSearchText] = useState<string>("");
  const [bookingInfoText, setBookingInfoText] = useState<string>("");
  const [bookingTitle, setBookingTitle] = useState<string>("");
  const [userSearchText, setUserSearchText] = useState<string>("");
  const [occupancyCount, setOccupancyCount] = useState(0);
  const [isPrivate, setIsPrivate] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<User>();
  const [userList, setUserList] = useState<User[]>([]);
  const [attendees, setAttendees] = useState<User[]>([]);
  const [showUserDropdown, setShowUserDropdown] = useState<boolean>(false);
  const [descText, setDescText] = useState<string>("");

  const [bookingLocation, setBookingLocation] = useState<GetMapsLocation>();
  const [bookingLocationId, setBookingLocationId] = useState<number | null>(null);
  const [bookingInterval, setBookingInterval] = useState<number>(15);

  const [showNoteView, setShowNoteView] = useState<boolean>(false);
  const [isSendMessage, setIsSendMessage] = useState<boolean>(false);
  const [iFramePayload, setIFramePayload] = useState<MapsIFrameData | null>(null);
  const [isIFrameLoaded, setIFrameLoaded] = useState<boolean>(false);
  const [isInitComplete, setIsInitComplete] = useState<boolean>(false);
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [conflictResource, setConflictResource] = useState<SelectedResourceObject | null>(null);

  const onSideBarChange = (isTrue: boolean) => {
    setIsFind(isTrue);
    setIFrameLoaded(false);

    if (isTrue) {
      setAvailableResourceList([]);

      const location = getMapsResponse?.Locations.find((loc) => loc.LocationId === bookingLocationId)
      setBookingLocation(location);
      getAvailableResources(
        {
          spaceType: selectedSpaceType,
          location: location,
          text: searchText,
          equipments: selectedEquipments,
          tags: selectedTags,
          occupancy: occupancyCount,
          startTime: bookingStartTime,
          endTime: bookingEndTime
        }
      );
    }
  };

  useEffect(() => {
    console.log("Theme Changed: ", theme);
  }, [themeString]);

  useEffect(() => {
    if (!selectedDate) return;

    const initBookingModel = async () => {
      setIsInitComplete(false);
      setBookingDate(selectedDate);
      setRecurringOptions(getRecurringOptionsForDate(selectedDate));

      Swal.fire({
        html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:15px;">
            <div class="swal2-loader" style="display:flex;"></div>
            <div style="font-size:16px;">
              Loading...
            </div>
          </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });

      const locationId =
        getSettingsData.data.DefaultLocation?.LocationId ?? null;

      loaderService.skipRequests(6);
      const [tags, equipment, resources, users, mapsLocations] = await Promise.all([
        SearchService.getSearchTagsList({ LocationId: locationId }),
        SearchService.getSearchEquipmentList({ LocationId: locationId }),
        SearchService.getAvailableResourceList(
          {
            Spacetype: [selectedSpaceType.name],
            Location: {
              LocationId: getSettingsData.data.DefaultLocation.LocationId,
              Country: getSettingsData.data.DefaultLocation.Country,
              City: getSettingsData.data.DefaultLocation.City,
              Site: getSettingsData.data.DefaultLocation.Site,
              Building: getSettingsData.data.DefaultLocation.Building,
              Floor: getSettingsData.data.DefaultLocation.Floor,
              Zone: getSettingsData.data.DefaultLocation.Zone,
            }
          }
        ),
        SearchService.searchUser({
          Id: [userId],
          EmailAddress: localStorage.getItem('userEmail') ?? "",
          Search: "",
          StartDateTime: "",
          EndDateTime: ""
        }),
        await getMaps()
      ]);

      setSearchTags(tags.Tags ?? []);
      setEquipmentList(equipment.ResEquipments ?? []);
      setAvailableResourceList(resources.SearchResultObjects ?? []);
      setCurrentUser(users.Users.length > 0 ? users.Users[0] : undefined);
      setGetMapsResponse(mapsLocations);

      const userLocation = getSettings.data.DefaultLocation
      let defaultLocation: GetMapsLocation | undefined;
      if (mapsLocations.Locations.length > 0) {
        defaultLocation = mapsLocations.Locations.find(loc =>
          loc.Country === userLocation.Country &&
          loc.City === userLocation.City &&
          loc.Site === userLocation.Site &&
          loc.Building === userLocation.Building &&
          loc.Floor === userLocation.Floor &&
          loc.Zone === userLocation.Zone
        );
        setBookingLocation(defaultLocation);
        setBookingLocationId(defaultLocation?.LocationId ?? 0);
      }

      const options = getBookingOptionsForDate(selectedDate, mapsLocations);
      setBookOptions(options);

      if (defaultLocation) {
        const hotspots = await getMapHotspots(defaultLocation.MapID);
        setGetMapHotspotsResponse(hotspots);
      }

      const isToday = moment(selectedDate).isSame(moment(), "day");
      if (isToday) {
        const eodOption = options.find(
          (opt) => opt.name === "End of day"
        );
        setSelectedBookOption(eodOption ? eodOption : secondaryBookOptions[0]);

        const withinWorking = isWithinWorkingHours(moment().toDate());
        const duration = withinWorking ? 15 : 60;
        setBookingInterval(duration);
        if (eodOption) {
          setValuesEODOption(selectedDate);
        } else {
          setValuesCustomOption(selectedDate, duration);
        }
      } else {
        const workingDayOption = options.find(
          (opt) => opt.name === "Working Day"
        );
        setBookingInterval(60);
        setSelectedBookOption(workingDayOption ?? secondaryBookOptions[0]);
        const start = getCombinedDateTime(bookingDate, mapsLocations.amStart)
        const end = getCombinedDateTime(bookingDate, mapsLocations.pmEnd)
        setBookingStartTime(start);
        setBookingEndTime(end);
        bookingStartTimeRef.current = start;
        bookingEndTimeRef.current = end;
      }

      setTimeout(() => {
        setIsInitComplete(true);
        Swal.close();
      }, 1000);
    };

    initBookingModel();
  }, [selectedDate]);

  useEffect(() => {
    availableResourcesRef.current = availableResourceList;
  }, [availableResourceList]);

  useEffect(() => {
    getMapsResponseRef.current = getMapsResponse;
  }, [getMapsResponse]);

  const getMaps = async (mapId?: number) => {
    let payload: GetMapsRequest = {}
    if (mapId) {
      payload = {
        mapid: mapId
      }
    }
    const response = await MapsService.getMaps(payload)
    return response;
  }

  const getMapHotspots = async (mapId: number) => {
    const payload: GetMapHotspotsRequest = {
      mapid: mapId,
      requestdate: moment(selectedDate).format("DDMMYYYY"),
      isMobileApi: false,
      loginuser: "true",
      bookings: true
    }
    const response = await MapsService.getMapHotspots(payload)
    return response;
  }

  const getBookingOptionsForDate = (date: Date, mapsResponse?: GetMapsEnhancedResponse | null) => {

    const workingDay = mapsResponse?.WorkingDay;
    const now = moment();
    const selected = moment(date);

    const isToday = selected.isSame(now, "day");
    const isFuture = selected.isAfter(now, "day");

    if (isFuture) {
      const filteredOptions = secondaryBookOptions.filter(
        (option) => option.code !== "EOD"
      );
      return [...filteredOptions];
    }

    if (!isToday) {
      return [...secondaryBookOptions];
    }

    if (!workingDay || workingDay.length === 0) {
      return [secondaryBookOptions[0]];
    }

    // Combine date + time properly
    const amStart = selected.clone().set({
      hour: Number(mapsResponse.amStart.split(":")[0]),
      minute: Number(mapsResponse.amStart.split(":")[1]),
      second: 0
    });

    const amFinish = selected.clone().set({
      hour: Number(mapsResponse.amEnd.split(":")[0]),
      minute: Number(mapsResponse.amEnd.split(":")[1]),
      second: 0
    });

    const pmStart = selected.clone().set({
      hour: Number(mapsResponse.pmStart.split(":")[0]),
      minute: Number(mapsResponse.pmStart.split(":")[1]),
      second: 0
    });

    const pmEnd = selected.clone().set({
      hour: Number(mapsResponse.pmEnd.split(":")[0]),
      minute: Number(mapsResponse.pmEnd.split(":")[1]),
      second: 0
    });

    // ---- Scenario Logic ----

    // Before AM start
    if (now.isBefore(amStart)) {
      return [...secondaryBookOptions];
    }

    // During AM
    if (now.isBetween(amStart, amFinish, undefined, "[)")) {
      return [
        secondaryBookOptions[0], // custom
        secondaryBookOptions[1], // AM
        secondaryBookOptions[2], // PM
        secondaryBookOptions[3], // EOD
      ];
    }

    // During PM
    if (now.isBetween(amFinish, pmEnd, undefined, "[)")) {
      return [
        secondaryBookOptions[0], // custom
        secondaryBookOptions[2], // PM
        secondaryBookOptions[3], // EOD
      ];
    }

    // After PM end
    if (now.isSameOrAfter(pmEnd)) {
      return [
        secondaryBookOptions[0], // custom
      ];
    }

    return [
      secondaryBookOptions[0], // custom
    ];
  };

  const onClickClose = () => {
    setOpen(false);
    triggerRef.current?.focus();
    onCloseModel(false);
  };

  const setDateFormat = () => {
    const timeFormat = getSettingsData.data.Is24HrFormat ? "HH:mm" : "hh:mm A"
        let newFormattype;
        switch (getSettingsData.data.DateFormat) {
            case ('dd/MM/yyyy'):
                return newFormattype = 'DD/MM/YYYY' + ' ' + timeFormat;
            case ('MM/DD/YYYY'):
                return newFormattype = 'MM/DD/YYYY' + ' ' + timeFormat;
            case ('MMMM, DD, YYYY'):
                return newFormattype = 'MMMM, DD, YYYY' + ' ' + timeFormat;
            case ('MMMM, dddd D, YYYY'):
                return newFormattype = 'MMMM, dddd D, YYYY' + ' ' + timeFormat;

            case ('dddd, D MMMM YYYY'):
                return newFormattype = 'dddd, D MMMM YYYY' + ' ' + timeFormat;
            case ('dddd Do MMMM YYYY'):
                return newFormattype = 'dddd Do MMMM YYYY' + ' ' + timeFormat;

            default:
                return newFormattype = 'DD/MM/YYYY' + ' ' + timeFormat;

        }
    }
    const dateFormat = setDateFormat();

  const onClickSave = async () => {

    if (selectedResourceList.length === 0) {
      return;
    }

    if (selectedRecurring && selectedRecurring.value !== 0 && reccuringEndDate === null) {
      ToastrService.error(t('SelectEndDate'));
      return;
    }

    try {
      Swal.fire({
        html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:15px;">
            <div class="swal2-loader" style="display:flex;"></div>
            <div style="font-size:16px;">
              Creating your booking...
            </div>
          </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });

      const endDateTime = selectedRecurring && selectedRecurring.value !== 0 ? getReccuringOptionsEndDate() : moment(bookingEndTime).format("DD/MM/YYYY HH:mm:ss");
      const bookOption = selectedRecurring === null ? selectedBookOption.code : selectedRecurring.value > 0 ? "" : selectedBookOption.code
      const payload: CreateBookingRequest = {
        Title: bookingTitle === "" ? "Smartbooking Session" : bookingTitle,
        Private: isPrivate,
        BookOption: bookOption,
        StartDateTime: moment(bookingStartTime).format("DD/MM/YYYY HH:mm:ss"),
        EndDateTime: endDateTime,
        Recurring: selectedRecurring?.value ?? 0,
        Description: bookingInfoText,
        User: { Id: userId, EmailAddress: localStorage.getItem('userEmail') ?? "" },
        Organiser: { Id: currentUser?.Id ?? 0, EmailAddress: currentUser?.EmailAddress ?? "" },
        Attendees: attendees.length === 0 ? [] : attendees.map(({ Id, EmailAddress }) => ({ Id, EmailAddress })),
        Resources: selectedResourceList.map(item => item.resource.Id)
      }

      console.log("CreateBooking Request: ", JSON.stringify(payload));
      loaderService.skipRequests(1);

      const createBookingResult: CreateBookingResponse = await UserBookingService.createBooking(payload);
      Swal.close();
      if ((createBookingResult.ErrCode === null || createBookingResult.ErrCode === "") && createBookingResult.Response === true) {
        Swal.fire({
          icon: "success",
          title: t('BookingCreated'),
          text: `${t('BookingCreated')} ${moment(bookingStartTime).format(dateFormat ? dateFormat : "DD/MM/YYYY HH:mm")} - ${moment(bookingEndTime).format(dateFormat ? dateFormat : "DD/MM/YYYY HH:mm")}.`,
          confirmButtonText: "Ok",
          showCancelButton: false,
          showCloseButton: false
        }).then(() => {
          onCloseModel(true, bookingDate);
        });
      } else {
        ToastrService.error(createBookingResult.ErrDesc);
      }
    } catch (error) {
      ToastrService.error(t('SomethingWentWrong'));
    }
  }

  const getReccuringOptionsEndDate = () => {
    const combinedDate = getCombinedDateTime(reccuringEndDate!, moment(bookingEndTime).format("HH:mm"));
    return moment(combinedDate).format("DD/MM/YYYY HH:mm:ss");
  }

  const onDialogKeydown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") {
      setOpen(false);
      triggerRef.current?.focus();
    }
  };

  useEffect(() => {
    if (open && dialogRef.current) {
      findFirstFocusable(dialogRef.current)?.focus();
    }
  }, [open, findFirstFocusable]);

  useEffect(() => {
    setOpen(true);
  }, [spaceDetails]);

  const handleBookingDateChange = (date: Date) => {
    setBookingDate(date);
    setSelectedResourceList([]);
    const options = getBookingOptionsForDate(date, getMapsResponse);
    setBookOptions(options);
    const isBookingOptionAvailable = options.some((opt) => opt.name === selectedBookOption.name)
    if (!isBookingOptionAvailable) {
      const getMappedBookOption = mapBookOptionsForDate(date, options)
      setSelectedBookOption(getMappedBookOption);
      setStartAndEndTime(date, getMappedBookOption, [])
    } else {
      setStartAndEndTime(date, selectedBookOption, [])
    }
  }

  const mapBookOptionsForDate = (date: Date, options: BookOption[]): BookOption => {
    const isToday = moment(date).isSame(moment(), "day");
    if (!isToday) {
      const workingDayOption = options.find(
        (opt) => opt.name === "Working Day"
      );

      return workingDayOption ?? options[0];
    } else if (isToday) {
      const isWorkingHour = isWithinWorkingHours(date);
      const eodOption = options.find(
        (opt) => opt.code === "EOD"
      );
      return isWorkingHour ? eodOption ?? options[0] : options[0];
    }
    return options[0];
  };

  const onBookingOptionsSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    const selected = bookOptions.find(
      (option) => option.name === data.optionValue
    );
    setSelectedBookOption(selected ?? bookOptions[0]);

    setStartAndEndTime(bookingDate, selected ?? bookOptions[0], selectedResourceList);
  };

  const isWithinWorkingHours = (date: Date): boolean => {
    if (!getMapsResponse?.amStart || !getMapsResponse?.pmEnd)
      return false;

    const selected = moment(date);

    const start = moment(date)
      .set({
        hour: moment(getMapsResponse.amStart, "HH:mm").hour(),
        minute: moment(getMapsResponse.amStart, "HH:mm").minute(),
        second: 0,
      });

    const end = moment(date)
      .set({
        hour: moment(getMapsResponse.pmEnd, "HH:mm").hour(),
        minute: moment(getMapsResponse.pmEnd, "HH:mm").minute(),
        second: 0,
      });

    return selected.isBetween(start, end, undefined, "[)");
  };

  const setValuesCustomOption = (date: Date, interval: number) => {
    const isToday = moment(date).isSame(moment(), "day");
    if (isToday) {
      const roundedStart = floorToInterval(moment().toDate(), SLIDER_STEP);
      setBookingStartTime(roundedStart);
      bookingStartTimeRef.current = roundedStart;
      setBookingEndTime(moment(roundedStart).add(interval, 'minutes').toDate());
      bookingEndTimeRef.current = moment(roundedStart).add(interval, 'minutes').toDate();
    } else {
      const roundedStart = floorToInterval(
        getCombinedDateTime(selectedDate, getMapsResponse?.amStart ?? "09:00"),
        SLIDER_STEP
      );
      setBookingStartTime(roundedStart);
      bookingStartTimeRef.current = roundedStart;
      setBookingEndTime(moment(roundedStart).add(interval, 'minutes').toDate());
      bookingEndTimeRef.current = moment(roundedStart).add(interval, 'minutes').toDate();
    }
  };

  const setValuesEODOption = (date: Date) => {
    const isToday = moment(date).isSame(moment(), "day");
    const workingDayEnd = getMapsResponse?.pmEnd ?? "17:00"
    if (isToday) {
      setBookingStartTime(floorToInterval(moment().toDate(), SLIDER_STEP));
      bookingStartTimeRef.current = floorToInterval(moment().toDate(), SLIDER_STEP);
      setBookingEndTime(getCombinedDateTime(date, workingDayEnd));
      bookingEndTimeRef.current = getCombinedDateTime(date, workingDayEnd);
    }
  };

  // MARK: - 
  //#region Start and End Time Handle
  const setStartAndEndTime = (date: Date, option: BookOption, selectedResources: SelectedResourceObject[]) => {
    const range = resolveBookingTime(date, option);
    if (!range) return;

    applyTimeRange(date, range, selectedResources);
  };

  const resolveBookingTime = (
    date: Date,
    option: BookOption
  ): { start: Date; end: Date } | null => {
    const amStart = getMapsResponse?.amStart ?? "09:00";
    const amEnd = getMapsResponse?.amEnd ?? "12:00";
    const pmStart = getMapsResponse?.pmStart ?? "14:00";
    const pmEnd = getMapsResponse?.pmEnd ?? "17:00";

    switch (option.name) {
      case "Custom": {
        const base = resolveRangeForToday(date, amStart, pmEnd, 15);
        if (!base) return null;

        return {
          start: base.start,
          end: moment(base.start).add(15, "minutes").toDate(),
        };
      }

      case "AM":
        return resolveRangeForToday(date, amStart, amEnd);

      case "PM":
        return resolveRangeForToday(date, pmStart, pmEnd);

      case "End of day":
        return resolveRangeForToday(date, pmStart, pmEnd, 15);

      case "Working Day":
        return resolveRangeForToday(date, amStart, pmEnd);

      case "All day":
        return {
          start: moment(date).startOf("day").toDate(),
          end: moment(date).endOf("day").toDate(),
        };

      default:
        return null;
    }
  };

  const resolveRangeForToday = (
    date: Date,
    startStr: string,
    endStr: string,
    roundTo?: number
  ): { start: Date; end: Date } | null => {
    const start = getCombinedDateTime(date, startStr);
    const end = getCombinedDateTime(date, endStr);

    const isToday = moment(date).isSame(moment(), "day");
    if (!isToday) return { start, end };

    const now = moment();
    const startMoment = moment(start);
    const endMoment = moment(end);

    if (now.isAfter(endMoment)) {
      const adjustedStart = floorToInterval(
        now.toDate(),
        SLIDER_STEP
      );

      const adjustedEnd = moment(adjustedStart)
        .add(roundTo ?? 60, "minutes")
        .toDate();

      return {
        start: adjustedStart,
        end: adjustedEnd,
      };
    }

    if (now.isBefore(startMoment)) {
      return { start, end };
    }

    const adjustedStart = roundTo
      ? floorToInterval(now.toDate(), SLIDER_STEP)
      : now.toDate();

    return { start: adjustedStart, end };
  };

  const applyTimeRange = (
    date: Date,
    range: { start: Date; end: Date },
    selectedResources: SelectedResourceObject[]
  ) => {
    console.log(range);
    setBookingStartTime(range.start);
    bookingStartTimeRef.current = range.start;
    setBookingEndTime(range.end);
    bookingEndTimeRef.current = range.end;

    getAvailableResources({
      startTime: range.start,
      endTime: range.end,
    });

    sendMessageToIframe({
      newDate: date,
      startTime: range.start,
      endTime: range.end,
      selectedResources: selectedResources
    });
  };




  //#endregion

  const getCombinedDateTime = (date: Date, time: string) => {
    const combinedDateTime = moment(date)
      .set({
        hour: moment(time, "HH:mm").hour(),
        minute: moment(time, "HH:mm").minute(),
        seconds: 0
      });

    return combinedDateTime.toDate();
  }

  const getRecurringOptionsForDate = (date: Date) => {
    const dayOfMonth = date.getDate();
    const weekdayIndex = date.getDay();
    const weekdayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const monthName = date.toLocaleDateString("en-US", { month: "long" });
    const weekOfMonth = getWeekOfMonth(date);

    return [
      {
        label: "Never",
        value: 0,
      },
      {
        label: "Every day",
        value: 1,
      },
      {
        label: "Every working day",
        value: 2,
      },
      {
        label: `Every ${weekdayName}`,
        value: 3,
      },
      {
        label: `Every ${getOrdinal(weekOfMonth)} ${weekdayName}`,
        value: 4,
      },
      {
        label: `Day ${dayOfMonth} of every month`,
        value: 5,
      },
      {
        label: `Every ${dayOfMonth}${getDaySuffix(dayOfMonth)} ${monthName}`,
        value: 6,
      },
    ];
  };

  const onReccuringOptionsSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    const selected = recurringOptions.find(
      (option) => option.label === data.optionText
    ) ?? null;

    setSelectedRecurring(selected);
  };

  const onReccuringDateSelect = (date: Date) => {
    const resolvedEndTime = getCombinedDateTime(date, moment(bookingEndTime).format("HH:mm"));
    setRecurringEndDate(resolvedEndTime);
    reccuringEndDateRef.current = resolvedEndTime;
    setBookingEndTime(resolvedEndTime);
    bookingEndTimeRef.current = resolvedEndTime;
    getAvailableResources({ endTime: resolvedEndTime });
  };

  const getAvailableResources = async ({
    location,
    text,
    spaceType,
    equipments,
    tags,
    occupancy,
    startTime,
    endTime
  }: {
    location?: ResourceLocation
    text?: string;
    spaceType?: ResourceSpaceType;
    equipments?: Equipment[];
    tags?: string[];
    occupancy?: number;
    startTime?: Date;
    endTime?: Date;
  } = {}) => {
    const resolvedLocation = location ?? bookingLocation;
    const resolvedSearchText = text ?? searchText;
    const resolvedSpaceType = spaceType ?? selectedSpaceType;
    const resolvedEquipments = equipments ?? selectedEquipments;
    const resolvedTags = tags ?? selectedTags;
    const resolvedOccupancy = occupancy ?? occupancyCount;
    const resolvedStartTime = startTime ?? bookingStartTimeRef.current;
    const resolvedEndTime = endTime ?? bookingEndTimeRef.current;
    try {
      const payload: GetAvailableResourceListRequest = {
        Location: resolvedLocation,
        Search: resolvedSearchText,
        Spacetype: [resolvedSpaceType.name],
        Equipment: resolvedEquipments.map(e => e.name),
        Keywords: resolvedTags,
        Occupancy: resolvedOccupancy,
        StartTime: moment(resolvedStartTime).format("DD/MM/YYYY HH:mm"),
        EndTime: moment(resolvedEndTime).format("DD/MM/YYYY HH:mm"),
      }

      const availableResources = await SearchService.getAvailableResourceList(payload);
      setAvailableResourceList(availableResources.SearchResultObjects ?? []);
    } catch (error) {
      console.error("Failed to fetch available space resources with error: ", JSON.stringify(error));
    }
  };

  const onSearchTextChange = (text: string) => {
    setSearchText(text);
    // if (text.length > 1) {
    getAvailableResources({ text: text });
    // }
  };

  const onBookingTitleChange = (text: string) => {
    setBookingTitle(text);
  };

  const onUserSearchChange = (text: string) => {
    setUserSearchText(text);
  };

  const onSpaceTypeChange = (selectedSpaceType: ResourceSpaceType) => {
    setSelectedSpaceType(selectedSpaceType);
    getAvailableResources({ spaceType: selectedSpaceType });
  };

  const onEquipmentsSelected = (selectedEquipments: Equipment[]) => {
    setSelectedEquipments(selectedEquipments);
    getAvailableResources({ equipments: selectedEquipments });
  };

  const onTagsSelected = (selectedTags: string[]) => {
    setSelectedTags(selectedTags);
    getAvailableResources({ tags: selectedTags });
  };

  const onOccupancyChange = (count: number) => {
    setOccupancyCount(count);
    getAvailableResources({ occupancy: count });
  }

  const isPrivateChange = (ev: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
    setIsPrivate(data.checked === true)
  };

  const onAddToBooking = async (resource: Resource) => {
    try {
      const resolvedStart = bookingStartTimeRef.current;
      const resolvedEnd = bookingEndTimeRef.current;
      const dateTimeObject: DateTimeObject = {
        StartDateTime: moment(resolvedStart).format("YYYY-MM-DDTHH:mm:ss"),
        EndDateTime: moment(resolvedEnd).format("YYYY-MM-DDTHH:mm:ss")
      }
      const payload: ResourceAvailabilityCheckRequest = {
        ResId: resource.Id,
        CheckDateTime: [dateTimeObject]
      }
      const availabilityResult: ResourceAvailabilityCheckResponse = await UserBookingService.checkResourceAvailability(payload);
      let newResource: SelectedResourceObject;
      if (availabilityResult.UnavailableDateTime.length > 0) {
        newResource = {
          resource: resource,
          availablity: false,
          unavailableDateTime: availabilityResult.UnavailableDateTime
        }
      } else {
        newResource = {
          resource: resource,
          availablity: true,
          unavailableDateTime: null
        }
      }

      setSelectedResourceList(prev => {
        if (prev.some(item => item.resource.Id === newResource.resource.Id)) {
          return prev;
        }
        return [...prev, newResource];
      });
    } catch (error) {
      console.log("ResourceAvailabilityCheck Error: ", JSON.stringify(error));
    }
  };

  const onRemoveResource = (index: number) => {
    setSelectedResourceList(prev => {
      const updatedList = prev.filter((_, i) => i !== index);
      console.log();

      // 🔥 Send message immediately using updated list
      sendMessageToIframe({
        selectedResources: updatedList,
      });

      return updatedList;
    });
  };

  useEffect(() => {
    console.log(bookingStartTime);
    console.log(bookingEndTime);
  }, [bookingStartTime, bookingEndTime]);

  const onAddAttendeeClick = async () => {
    if (showUserDropdown) {
      setShowUserDropdown(false);
      return
    }
    await userSearchAPI();
    setShowUserDropdown(true);
  }

  const userSearchAPI = async (searchText?: string) => {
    try {
      const payload: UserSearchRequest = {
        Id: [],
        EmailAddress: localStorage.getItem('userEmail') ?? "",
        Search: searchText ? searchText : "",
        StartDateTime: moment(bookingStartTime).format("DD/MM/YYYY HH:mm"),
        EndDateTime: moment(bookingEndTime).format("DD/MM/YYYY HH:mm")
      }

      const userSearchResult = await SearchService.searchUser(payload);
      const filteredUsers = userSearchResult.Users.filter((user) => user.Id !== userId)
      setUserList(filteredUsers);

    } catch (error) {

    }
  };

  const addAttendee = (user: User) => {
    setAttendees(prev => { return [...prev, user]; });
  };

  const removeAttendee = (removeUser: User) => {
    const updatedAttendees = attendees.filter(
      (user: User) => user.Id !== removeUser.Id
    );

    setAttendees(updatedAttendees);
  };

  const onBookingInfoChange = (ev: ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) => {
    setBookingInfoText(data.value);
  }

  const onStartTimeChange = (date: Date) => {
    setBookingStartTime(date);
    bookingStartTimeRef.current = date;
    getAvailableResources({ startTime: date });
    sendMessageToIframe({ startTime: date })
  };

  const onEndTimeChange = (date: Date) => {
    if (moment(date).isBefore(bookingStartTime)) {
      ToastrService.error(t('EndTimeError'));
      return;
    }
    setBookingEndTime(date);
    bookingEndTimeRef.current = date;
    getAvailableResources({ endTime: date });
    sendMessageToIframe({ endTime: date })
  };

  const launchNotes = () => {
    setShowNoteView(true);
  }

  const closeNotes = () => {
    setShowNoteView(false);
  }

  const htmlToText = (html: string): string => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const onDescTextChange = (text: string) => {
    const plainText = htmlToText(text);
    setBookingInfoText(text);
  };

  const onBookingLocationChange = (location: GetMapsLocation) => {
    setBookingLocation(location);
    setBookingLocationId(location.LocationId);
    const queryLocation: ResourceLocation = {
      LocationId: location.LocationId,
      Country: location.Country,
      City: location.City,
      Site: location.Site,
      Building: location.Building,
      Floor: location.Floor,
      Zone: location.Zone
    }
    getAvailableResources({ location: queryLocation });
  };

  const onReceiveMessageFromMaps = async (message: MapsIFrameData) => {
    if (message.data) {
      handleIframeUpdatesPayload(message.data);
    }
    if (message.action) {
      handleIframeOnLoadPayload(message);
    }
  }

  const handleIframeOnLoadPayload = async (payload: MapsIFrameData) => {
    if (!payload.action || payload.action !== "loaded") return;

    if (!isIFrameLoaded) {
      sendMessageToIframe();
      setIFrameLoaded(true);
    }

    if (payload.locationId && bookingLocation?.LocationId !== payload.locationId) {
      setBookingLocationId(payload.locationId);
    }
  };

  const handleIframeUpdatesPayload = async (payload: DataObject) => {
    if (payload.date === "") return;

    // const startTimeStr = moment(bookingStartTime).format("HH:mm");
    // const endTimeStr = moment(bookingEndTime).format("HH:mm");

    // if (startTimeStr !== payload.timeRange.start || endTimeStr !== payload.timeRange.end) {

    // }

    if (
      payload.spaceType &&
      payload.spaceType.length > 0 &&
      payload.spaceType[0] !== selectedSpaceType?.name
    ) {
      const newSpaceType = allSpaceTypes.find(
        (type) => type.name === payload.spaceType[0]
      );

      if (newSpaceType) {
        setSelectedSpaceType(newSpaceType);
      }
    }

    const incomingEquipmentNames = payload.equipment ?? [];

    // if (payload.equipment) {
    const newSelectedEquipments = equipmentList.filter((equip) =>
      incomingEquipmentNames.includes(equip.name)
    );

    const isDifferent =
      newSelectedEquipments.length !== selectedEquipments.length ||
      newSelectedEquipments.some(
        (equip, index) => equip.id !== selectedEquipments[index]?.id
      );

    if (isDifferent) {
      setSelectedEquipments(newSelectedEquipments);
    }

    const incomingTags = payload.tags ?? [];
    const isDifferentTags =
      incomingTags.length !== selectedTags.length ||
      incomingTags.some((tag) => !selectedTags.includes(tag));

    if (isDifferentTags) {
      setSelectedTags(incomingTags);
    }

    if (payload.selectedResources && payload.selectedResources.length > 0) {
      // const allResources = availableResourcesRef.current || [];
      const allResources = await SearchService.getAvailableResourceList({});

      if (allResources.SearchResultObjects.length > 0) {
        payload.selectedResources.forEach(async (selectedResource) => {
          const alreadyExists = selectedResourceList.some(
            (resource) => resource.resource.Id === selectedResource.Id
          );

          if (!alreadyExists) {
            const newResource = allResources.SearchResultObjects.find(
              (resource) => resource.Id === selectedResource.Id
            );

            if (newResource) {
              handleIframeTimeChange(payload.date, payload.timeRange.start, payload.timeRange.end, newResource);
            }
          }
        });
      }
    } else {
      handleIframeTimeChange(payload.date, payload.timeRange.start, payload.timeRange.end);
      setSelectedResourceList([]);
    }
  };

  const handleIframeTimeChange = async (date: string, start: string, end: string, newResource?: Resource) => {
    const newDate = moment(date, "DD/MM/YYYY").toDate();

    const newStartTime = getCombinedDateTime(newDate, start);
    let newEndTime = getCombinedDateTime(newDate, end);

    if (reccuringEndDateRef.current) {
      newEndTime = bookingEndTimeRef.current;
    }
    setBookingStartTime(newStartTime);
    setBookingEndTime(newEndTime);

    detectSlotType(start, end, getMapsResponseRef.current || {});

    if (newResource) {
      await onAddToBooking(newResource);
    }
  };

  const detectSlotType = (
    start: string,
    end: string,
    slots: {
      amStart?: string;
      amEnd?: string;
      pmStart?: string;
      pmEnd?: string;
      workdayStart?: string;
      workdayEnd?: string;
    }
  ) => {
    const { amStart, amEnd, pmStart, pmEnd, workdayStart, workdayEnd } = slots;

    const customOption = bookOptions.find((opt) => opt.name === "Custom");
    const defaultOption = bookOptions[0];

    const startMoment = moment(start, "HH:mm");
    const endMoment = moment(end, "HH:mm");

    const today = moment().isSame(moment(), "day");
    if (start === amStart && end === amEnd) {
      const amOption = bookOptions.find((opt) => opt.code === "AM");
      setSelectedBookOption(amOption ?? customOption ?? defaultOption);
    }
    else if (start === pmStart && end === pmEnd) {
      const pmOption = bookOptions.find((opt) => opt.code === "PM");
      setSelectedBookOption(pmOption ?? customOption ?? defaultOption)
    }
    else if (start === workdayStart && end === workdayEnd) {
      const wdOption = bookOptions.find((opt) => opt.code === "WD");
      setSelectedBookOption(wdOption ?? customOption ?? defaultOption)
    }
    else if (
      today &&
      amStart &&
      amEnd &&
      startMoment.isBetween(moment(amStart, "HH:mm"), moment(amEnd, "HH:mm"), undefined, "[)") &&
      end === amEnd
    ) {
      const amOption = bookOptions.find((opt) => opt.code === "AM");
      setSelectedBookOption(amOption ?? customOption ?? defaultOption);
    }
    else if (
      today &&
      pmStart &&
      pmEnd &&
      startMoment.isBetween(moment(pmStart, "HH:mm"), moment(pmEnd, "HH:mm"), undefined, "[)") &&
      end === pmEnd
    ) {
      const pmOption = bookOptions.find((opt) => opt.code === "PM");
      setSelectedBookOption(pmOption ?? customOption ?? defaultOption);
    }
    else if (end === workdayEnd) {
      const nowFloored = floorToInterval(new Date(), SLIDER_STEP);

      const startMoment = moment(start, "HH:mm");
      const nowMoment = moment(nowFloored);

      if (startMoment.isSame(nowMoment, "minute")) {
        const eodOption = bookOptions.find((opt) => opt.code === "EOD");
        setSelectedBookOption(eodOption ?? customOption ?? defaultOption);
      } else {
        setSelectedBookOption(customOption ?? defaultOption)
      }
    }
    else {
      setSelectedBookOption(customOption ?? defaultOption)
    }
  };

  const sendMessageToIframe = ({
    newDate,
    startTime,
    endTime,
    selectedResources
  }: {
    newDate?: Date,
    startTime?: Date;
    endTime?: Date;
    selectedResources?: SelectedResourceObject[]
  } = {}) => {

    if (isFind) return;
    const resolvedBookingDate = newDate ? newDate : bookingDate
    const resolvedStartTime = startTime ? startTime : bookingStartTime
    const resolvedEndTime = endTime ? endTime : bookingEndTime
    const resolvedSelectedResources = selectedResources ? selectedResources : selectedResourceList
    const payloadData: DataObject = {
      date: moment(resolvedBookingDate).format("DD/MM/YYYY"),
      timeRange: {
        start: moment(resolvedStartTime).format("HH:mm"),
        end: moment(resolvedEndTime).format("HH:mm")
      },
      spaceType: selectedSpaceType.name,
      occupancy: occupancyCount,
      tags: selectedTags,
      equipment: selectedEquipments.map((equipment) => equipment.name),
      theme: theme ?? "light",
      selectedResources: getMapHotspotsResponse
        ? getMapHotspotsResponse?.MapResources
          .filter(hotspot =>
            resolvedSelectedResources.some(
              res => res.resource.Id === hotspot.Id
            )
          )
          .map(hotspot => ({
            ...hotspot,
            Info: {
              ...hotspot.Info,
              Keywords: Array.isArray(hotspot.Info?.Keywords)
                ? hotspot.Info.Keywords
                : hotspot.Info?.Keywords
                  ?.split(",")
                  .map(k => k.trim()) ?? []
            },
            selected: true
          }))
        : []
    }
    const payload: MapsIFrameData = {
      from: "workplaces",
      data: payloadData
    };
    setIFramePayload(payload);
    console.log("sendMessageToIframe setIFramePayload: ", payload);
    setIsSendMessage(true);
  };

  const onConflictTap = (index: number) => {
    console.log("Conflict Tapped At Index: ", index);
    console.log("Conflict Resource At Index: ", selectedResourceList[index]);

    // setConflictResource(selectedResourceList[index]);
    // setShowOverlay(true);
  }

  const onCloseConflictView = () => {
    setConflictResource(null);
    setShowOverlay(false);
  };

  return (
    <div>
      {open && (
        <div
          onKeyDown={onDialogKeydown}
          ref={dialogRef}
          // {...modalAttributes}
          aria-modal="true"
          role="dialog"
          className={styles.container}
        >
          <div
            className={styles.dialog}
            style={{
              display: "grid",
              gridTemplateColumns: "64px 1px 375px 1px auto",
              height: "100%",
              overflow: "hidden",
              backgroundColor: theme === "light" ? "#FFFFFF" : "#1A1A1A"
            }}
          >
            <div
              style={{
                borderRight: "1px solid #525252"
              }}
            >
              <ResourceSpaceSideBar isFind={isFind} setIsFind={onSideBarChange} theme={theme ?? 'light'} />
            </div>

            <div style={{}} />

            <div
              className={styles.bookingScroll}
            >
              {isInitComplete && (
                <ResourceSpaceBooking
                  theme={theme ?? "light"}
                  onBookingTitleChange={onBookingTitleChange}
                  isPrivate={isPrivate}
                  isPrivateToggle={isPrivateChange}
                  selectedDate={bookingDate}
                  addedResources={selectedResourceList}
                  onDateChange={handleBookingDateChange}
                  onCloseModel={onClickClose}
                  removeResource={onRemoveResource}
                  addAttendeeClick={onAddAttendeeClick}
                  currentUser={currentUser!}
                  usersList={userList}
                  addedUsersList={attendees}
                  showUserDropdown={showUserDropdown}
                  onAddAttendee={addAttendee}
                  userSearchText={userSearchText}
                  userSearchTextChange={onUserSearchChange}
                  recurringOptions={recurringOptions}
                  selectedRecurringOption={selectedRecurring}
                  reccuringOptionSelect={onReccuringOptionsSelect}
                  onReccuringDateChange={onReccuringDateSelect}
                  reccuringEndDate={reccuringEndDate}
                  bookOptions={bookOptions}
                  bookOptionsChange={onBookingOptionsSelect}
                  selectedBookOption={selectedBookOption}
                  bookStartTime={bookingStartTime}
                  bookEndTime={bookingEndTime}
                  onSaveAction={onClickSave}
                  onRemoveAttendee={removeAttendee}
                  bookingInfoText={bookingInfoText}
                  bookingInfoChange={onBookingInfoChange}
                  onStartTimeChange={onStartTimeChange}
                  onEndTimeChange={onEndTimeChange}
                  showNoteView={showNoteView}
                  onLaunchNoteClick={launchNotes}
                  timeInterval={bookingInterval}
                  onConflictClick={onConflictTap}
                  conflictViewShown={showOverlay}
                />
              )}
            </div>

            <div style={{}} />

            <div style={{ position: "relative", height: "100%", width: "100%" }}>
              {(isFind && bookingLocationId) ? (
                <div
                  style={{
                    // overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    borderRight: "1px solid #525252",
                    height: "100%"
                  }}
                >
                  <ResourceSpaceFindSection
                    theme={theme ?? "light"}
                    spaceType={selectedSpaceType}
                    spaceTypes={allSpaceTypes}
                    equipmentList={equipmentList}
                    tagsList={searchTags}
                    availableResourceList={availableResourceList}
                    selectedResourceList={selectedResourceList.map(item => item.resource)}
                    onChangeSearchText={onSearchTextChange}
                    onChangeSpaceType={onSpaceTypeChange}
                    onEquipmentSelect={onEquipmentsSelected}
                    onTagsSelect={onTagsSelected}
                    selectedEquipmentList={selectedEquipments}
                    selectedTagsList={selectedTags}
                    onChangeOccupancyCount={onOccupancyChange}
                    occupancyCount={occupancyCount}
                    addToBookingAction={onAddToBooking}
                    initialLocation={bookingLocation ?? getSettings.data.DefaultLocation}
                    onLocationChange={onBookingLocationChange}
                    getMapsResponse={getMapsResponse}
                  />
                </div>
              ) : (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {(bookingLocationId && isInitComplete) && (
                    <ResourceSpaceMapSection
                      key={`${bookingLocation?.MapID}-${isFind}`}
                      mapId={bookingLocation?.MapID ?? 0}
                      payload={iFramePayload}
                      onReceiveMessage={onReceiveMessageFromMaps}
                      isSendMessageToIframe={isSendMessage}
                    />
                  )}
                </div>
              )}
              {/* Overlay View */}
              {showOverlay && (
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    left: 20,
                    width: 319,
                    height: "calc(95vh - 45px)",
                    borderRadius: 6,
                    backgroundColor: "transparent",
                    zIndex: 1000
                  }}
                >
                  {conflictResource && (
                    <ConflictView
                      theme={theme ?? "light"}
                      resource={conflictResource}
                      option={selectedRecurring}
                      startTime={bookingStartTimeRef.current}
                      endTime={bookingEndTimeRef.current}
                      onClose={onCloseConflictView} />
                  )}
                </div>
              )}
            </div>
          </div>

          {showNoteView && (
            <RXRTEView isOpen={showNoteView} closeTextView={closeNotes} value={bookingInfoText} onChange={(text) => { onDescTextChange(text) }} />
          )}
        </div>
      )}
    </div>
  );
};

export default ResourceSpaceTypeModel;
